<template>
  <div class="tabs-work">
    <div class="works-menu tabs-work__menu c_ui5_menu_dotted">
      <div class="works-menu__link-wrapper">
        <div class="works-menu__left-container">
          <div v-for="menu_item in menu_items" :class="{'active': is_route_active(menu_item.route, menu_item.click)}" class="works-menu__item" data-position="left">

            <a v-if="!(userId>0) && menu_item.click=='login'" :onclick="'action_user.show_popup_login(this, \'\', \''+make_link(menu_item.link)+'\');'" class="works-menu__link pointer">
              {{ menu_item.label }}
            </a>
            <a v-else :href="make_link(menu_item.link)" v-on:click="menu_click($event, menu_item.click)" class="works-menu__link pointer">
              {{ menu_item.label }}
            </a>

          </div>
        </div>

        <div class="works-menu__right-container"/>
      </div>

      <div class="works-menu__button">
        <div class="works-menu__button-dot"/>
        <div class="works-menu__button-dot"/>
        <div class="works-menu__button-dot"/>
      </div>

      <div class="works-menu__popup">
        <div class="works-menu__popup-wrapper">
          <div class="works-menu__popup-item-wrapper">
            <div v-for="menu_item in menu_items" :class="{'active': is_route_active(menu_item.route, menu_item.click)}" class="works-menu__popup-item">

              <a v-if="!(userId>0) && menu_item.click=='login'" :onclick="'action_user.show_popup_login(this, \'\', \''+make_link(menu_item.link)+'\');'" class="works-menu__popup-link pointer">
                {{ menu_item.label }}
              </a>
              <a v-else :href="make_link(menu_item.link)" v-on:click="menu_click($event, menu_item.click)" class="works-menu__popup-link pointer">
                {{ menu_item.label }}
              </a>

            </div>
          </div>

          <div class="works-menu__popup-item-wrapper">
            <div class="works-menu__popup-close">
              <div class="works-menu__popup-close-icon">
                <div class="svg-icon svg-icon_size-24px"><svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <path d="M19 6.41L17.59 5L12 10.59L6.41 5L5 6.41L10.59 12L5 17.59L6.41 19L12 13.41L17.59 19L19 17.59L13.41 12L19 6.41Z" fill="#202020"/>
                </svg>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <a :href="make_link('artworks/sell')" class="button-default button-default-blue-bg button-default_size-40">
      <div class="svg-icon svg-icon_size-10px">
        <svg width="10" height="10" viewBox="0 0 10 10" fill="none"><path fill-rule="evenodd" clip-rule="evenodd" d="M6 0H4V4L0 4V6H4V10H6V6H10V4L6 4V0Z" fill="white"/></svg>
      </div>
      <span class="button-default__delimiter"/>
      <span class="button-default__name">
        {{ $t("message.AddWork") }}
      </span>
    </a>
  </div>
</template>

<script>
  export default {
    name      : 'nav-bar8',
    data() {
      return {
        menu_items:[
          { route:'MainWorks', link:'/artworks', click:'', label:this.$t("message.ArtworksMain") }, //Главная
          { route:'SaleWorks', link:'/artworks/for_sale', click:'sale', label:this.$t("message.ArtworksForSale") }, //Работы в продаже
          { route:'AllWorks', link:'/artworks/all', click:'all', label:this.$t("message.AllWorks") }, //Все работы
          //{ route:'PickedWorks', link:'/artworks/picked', click:'picked', label:this.$t("message.ArtworksPicked") }, //Выбор редакции

          /*{ route:'SaleWorks', link:'/artworks/for_sale/saletype:orig', click:'sale_orig', label:this.$t("message.ArtworksForSaleOrig") }, //Оригиналы
          { route:'SaleWorks', link:'/artworks/for_sale/saletype:repr', click:'sale_repr', label:this.$t("message.ArtworksForSaleRepr") }, //Репродкции
          { route:'SaleWorks', link:'/artworks/for_sale/saletype:digital', click:'sale_digital', label:this.$t("message.ArtworksForSaleDigital") }, //Цифровые копии
          */

          { route:'DebutWorks', link:'/artworks/debut', click:'', label:this.$t("message.Debut") }, //Дебют
          { route:'MyWorks', link:'/artworks/my', click:'login', label:this.$t("message.ArtworksMy") }, //Мои произведения
          { route:'LikedWorks', link:'/artworks/liked', click:'login', label:this.$t("message.ArtworksLiked") }, //Мне понравились
        ],
      }
    },
    computed: {
      userId: {
        get() {
          return this.$store.getters.userId
        }
      },
    },
    methods: {
      is_route_active(route, click) {
        let cur_route=this.$route.name;
        let res=(cur_route.indexOf(route) === 0 || cur_route.indexOf("_" + route) === 0);
        /*if ( res && route=='SaleWorks' ){
          let cur_sale_type=this.$store.getters.filters.saletype;
          if ( cur_sale_type==null && click!='sale' ) res=false;
          if ( cur_sale_type=='orig' && click!='sale_orig' ) res=false;
          if ( cur_sale_type=='repr' && click!='sale_repr' ) res=false;
          if ( cur_sale_type=='digital' && click!='sale_digital' ) res=false;
        }*/
        return res;
      },

      make_link( link ){
        if ( link.substr(0,1)=='/' ) link=link.substr(1);
        return document.site_short_url_lang + link;
      },

      menu_click(event, part){
        if ( part==null || part.length==0 ) return;
        let cur_route=this.$route.name;
        if ( (cur_route.indexOf('MainWorks') === 0 || cur_route.indexOf('_MainWorks') === 0) ) return;
        if ( (cur_route.indexOf('DebutWorks') === 0 || cur_route.indexOf('_DebutWorks') === 0) ) return;
        if ( (cur_route.indexOf('MyWorks') === 0 || cur_route.indexOf('_MyWorks') === 0) ) return;
        if ( (cur_route.indexOf('LikedWorks') === 0 || cur_route.indexOf('_LikedWorks') === 0) ) return;
        if ( (cur_route.indexOf('AddWorks') === 0 || cur_route.indexOf('SellWorks') === 0) ) return;

        switch (part){
          case 'all':
            //все работы
            event.preventDefault();
            window._gl_vue_change_route=true;//чтобы заменить route на AllWorks
            let params={'p':1, saletype:false/*, picked:false*/};
            if ( this.$store.getters.filters.sort!=null && (this.$store.getters.filters.sort=='price' || this.$store.getters.filters.sort=='low_price') ) params.sort='';
            this.$store.dispatch('setFilters', params).then (() => { });
          break;

          /*case 'picked':
            //выбор редакции
            event.preventDefault();
            let params1={'p':1, saletype:false, picked:'y'};
            //if ( this.$store.getters.filters.sort!=null && (this.$store.getters.filters.sort=='price' || this.$store.getters.filters.sort=='low_price') ) params1.sort='';
            this.$store.dispatch('setFilters', params1).then (() => { });
          break;*/

          case 'sale':
            //работы в продаже
            event.preventDefault();
            this.$store.dispatch('setFilters', {'p':1, saletype:'all'/*, picked:false*/}).then (() => { });
          break;

          /*case 'sale_orig':
            //оригиналы в продаже
            event.preventDefault();
            this.$store.dispatch('setFilters', {'p':1, saletype:'orig', picked:false}).then (() => { });
          break;

          case 'sale_repr':
            //репродукции в продаже
            event.preventDefault();
            this.$store.dispatch('setFilters', {'p':1, saletype:'repr', picked:false}).then (() => { });
          break;

          case 'sale_digital':
            //цифровые версии в продаже
            event.preventDefault();
            this.$store.dispatch('setFilters', {'p':1, saletype:'digital', picked:false}).then (() => { });
          break;*/
        }
      },
    },
  }
</script>



// WEBPACK FOOTER //
// src/components/NavBar8.vue